import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Passkey — registered devices. */
export function PasskeyIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="8.4" cy="14.4" r="3.6" />
      <path d="M11.2 11.6 19 3.8M15.6 7.2l2.4 2.4M13 9.8l1.8 1.8" />
    </PortalIcon>
  );
}
